exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-up-dialog-wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 100001;\n  background-color: #000;\n  padding: 40px;\n}\n.pop-up-dialog-wrapper .close-icon {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  cursor: pointer;\n}\n.back-click-blocker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  /*dim the background*/\n  z-index: 99999;\n}\nimg {\n  max-width: 90vw;\n  max-height: 90vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/image-preview/image-preview.component.less
// module id = ../../../../../src/app/shared/image-preview/image-preview.component.less
// module chunks = main